import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../helpers';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { environment } from '../../environments/environment';
import { CommonModule, DatePipe } from "@angular/common";
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription } from 'rxjs';
import * as moment from 'moment';
import { WaypointsMapComponent } from '../map/WaypointsMap/Waypoints.component';
import { interval } from 'rxjs/observable/interval';
declare var google: any;

declare var $: any;
@Component({
  selector: 'app-bid-transporter',
  templateUrl: './bid-transporter.component.html',
  styleUrls: ['./bid-transporter.component.scss']
})
export class BidTransporterComponent implements OnInit {
  ShowAvailabilityDate: boolean = true;
  totalBidAmount: number = 0;
  totalRateAmount: number = 0;
  selectedVehicles: { VehicleReqiredId: any, AvailableDate: any, VehicleAmount: any }[] = [];
  OrderData: any = {};
  static that: BidTransporterComponent;
  IndentId: string = '';
  SumOfQty: any = 0;
  SumOfWeight: any = 0;
  TransporterList: any[] = [];
  TransporterId: any = '';
  BidTransporter: any = {};
  isBidOpen: boolean = true;
  whitelabelFlag: boolean = false;
  //added by vithujan 19-06-2023
  hostUrl: any = environment.apiUrl;
  VehicleDetails: any[]
  AvailableDate: any;
  VehicleReqiredId: any;
  CompanyId: any;
  UserId: any;
  currentDate: any;
  VehicleData: any = [];
  BookingId: any;
  lowestBidAmount: any = 0;

  ShipNowChargeBreakupList:any=[];  //added by fahim 05-01-2026 :)
  ChargeBreakupTotalQty:any;   //added by fahim 05-01-2026 :)
  ChargeBreakupTotalRate:any;   //added by fahim 05-01-2026 :)
  ChargeBreakupTotalAmount:any;  //added by fahim 05-01-2026 :)
  selectedRate=0;  //added by fahim 05-01-2026 :)
  selectedAmount=0;  //added by fahim 05-01-2026 :)
  totalChargeRateAmount: number = 0;

  TransportersBidsId: string = '';  //added by fahim 19-01-2026 :)
  NewselectedVehicles:any=[];   //added by fahim 20-01-2026 :)
  NewVehicleDetails: any = []; //added by fahim 20-01-2026 :)
  selectedVehiclesNEW: any = []; //added by fahim 20-01-2026 :)

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private CommonModule: CommonModule,
    private _script: ScriptLoaderService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private datepipe: DatePipe,
    private cdRef: ChangeDetectorRef
  ) {
    BidTransporterComponent.that = this;
  }

  ngOnInit() {
    this._script.loadScripts(
      "body",
      [
        "assets/vendors/base/vendors.bundle.js",
        "assets/demo/default/base/scripts.bundle.js"
      ],
      true
    )
      .then(() => {
        this._activatedRoute.params.subscribe((params: Params) => {
          this.IndentId = this._activatedRoute.snapshot.queryParams["IndentId"];
          this.TransporterId = this._activatedRoute.snapshot.queryParams["Transporter"];
          this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));
          this.BookingId = this._activatedRoute.snapshot.queryParams["BookingId"];

          this.TransportersBidsId = this._activatedRoute.snapshot.queryParams["TransportersBidsId"];  //added by fahim 05-01-2026 :)

          if (this.IndentId == undefined || this.IndentId == null) {
            this.IndentId = this._activatedRoute.snapshot.queryParams["indentid"];
            this.TransporterId = this._activatedRoute.snapshot.queryParams["transporter"];
            this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelflag"));
            this.BookingId = this._activatedRoute.snapshot.queryParams["BookingId"];
          }
          if (this.IndentId !== undefined && this.IndentId !== null) {
            this.GetRequiredData();
          }

          if (this.BookingId !== undefined && this.BookingId !== null) {
            this.TransporterId = this._activatedRoute.snapshot.queryParams["Transporter"];
            this.TripDataForBidding();
            this.GetAddressSequenceById();
            this.VehicleData = [];
          }
          this.startInterval();
        });
        this.RefreshvalidDate();
        this.calculateTotalBidAmount();
      });
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0];
  }

  stopInterval() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  GetRequiredData() {
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleById", this.IndentId, this.TransporterId).subscribe(
      (response) => {
        this.OrderData = response;
        this.CalcSum();
        this.getVehicleRate();
        setTimeout(() => {
          this.calculateTotalRateAmount();
        }, 1000);
        this.GetTransporterListHired();

        if (this.OrderData.BidOpen == false || this.OrderData.BidOpen == null) {
          this.isBidOpen = true;
        } else {
          this.isBidOpen = false;
        }

        if (!this.isBidOpen) {
          this.stopInterval();
        }

        // if( this.OrderData &&
        //     Array.isArray(this.OrderData.VehicleList) &&
        //     this.OrderData.VehicleList.length > 0
        //   ){
        //   this.NewselectedVehicles = this.OrderData.VehicleList.map((vehicle: any) => ({
        //     VehicleTypeName: vehicle.VehicleTypeName,
        //     AvailableDate: this.currentDate,
        //     Qty: vehicle.Qty,
        //     VehicleAmount: vehicle.VehicleAmount || 0,
        //     VehicleReqiredId: vehicle.Id,
        //     VehicleTypeId: vehicle.VehicleType,
        //     NewVehicleTypeId: vehicle.VehicleType,
        //   }));
        // }

        

        //added by fahim 20-01-2026 :)
        if (this.TransportersBidsId !== undefined && this.TransportersBidsId !== null) {
          this.GetTransportersBidsById();
        }

        //added by fahim 20-01-2026 :)
        this.GetBidDetails();
        // console.log('IsContracted',this.OrderData.IsContracted,typeof this.OrderData.IsContracted);
        // if(this.OrderData && this.OrderData.IsContracted === 'true'){
        //   this.GetShipNowChargeBreakupList();
        // }
      },
      (err) => {
        this.toastr.error(
          "An erro occured while Update Data",
          "ChargeType"
        );
      }
    );
  }

  getVehicleRate() {
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleRate", this.IndentId, this.TransporterId).subscribe(
      (response) => {
        this.VehicleData = response;
      },
      (err) => {
        console.log(err)
      }
    );
  }

  CalcSum() {
    for (let i = 0; i < this.OrderData.ProductList.length; i++) {
      this.SumOfQty += (this.OrderData.ProductList[i].Qty ? this.OrderData.ProductList[i].Qty : 0);
      this.SumOfWeight += (this.OrderData.ProductList[i].weight ? this.OrderData.ProductList[i].weight : 0);
    }
  }

  GetTransporterListHired() {
    this._appService
      .Get("OrdersByVehicle", "GetTranspoterListHired")
      .subscribe(
        (response) => {

          var res = response;
          var transporter = res.find(c => c.Id == this.TransporterId);
          this.TransporterList.push(
            transporter
          );
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  UpdateTransporterBids() {

    if (this.selectedVehicles.length == 0) {
      this.toastr.info('Please Select Atleast One VehcileType', 'info')
      return
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#Amount"),
        "Please Enter Bid Amount",
        "after",
        ""
      )
    ) {
      return;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#transporter"),
        "Please select",
        "after",
        ""
      )
    ) {
      return;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#AvailableDate"),
        "Please select Date",
        "after",
        ""
      )
    ) {
      return;
    }
    this.BidTransporter.Amount = this.totalBidAmount;
    this.VehicleDetails = this.selectedVehicles;
    this.BidTransporter.IndentId = this.IndentId;
    this.BidTransporter.TransporterId = this.TransporterId;
    this.BidTransporter.Vehicleslist = this.VehicleDetails
    this.BidTransporter.IsContracted = false
    this._appService
      .Post("OrdersByVehicle", "UpdateTransporterBid", this.BidTransporter)
      .subscribe(
        (response) => {
          Helpers.setLoading(false);

          if (response[0].isDone) {
            this.toastr.success("Bid Sent sucessfully !", "Success");
          } else {
            this.toastr.error("Your Bid Submission Failed !", "Error");
          }

        },
        (err) => {
          console.log(err);
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  RefreshvalidDate() {
    setTimeout(() => {
      $(".datepickerforSalesRegister").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }

  onDateChange(event: any, VehicleReqiredId: any) {
    const AvailableDate = event.target.value;
    this.currentDate = event.target.value
    const vehicle = this.selectedVehicles.find(vehicle => vehicle.VehicleReqiredId === VehicleReqiredId);
    if (vehicle) {
      vehicle.AvailableDate = AvailableDate;
    } else {
      const selectedVehicle = this.OrderData.VehicleList.find(v => v.Id === VehicleReqiredId);
      if (selectedVehicle) {
        this.selectedVehicles.push({
          VehicleReqiredId,
          AvailableDate,
          VehicleAmount: selectedVehicle.VehicleAmount || ''
        });
      }
    }
    this.calculateTotalBidAmount();
    this.calculateTotalRateAmount();
  }

  onCheckboxChange(event: any, vehicle: any) {
    const VehicleReqiredId = vehicle.Id;
    if (event.target.checked) {
      this.selectedVehicles.push({
        VehicleReqiredId,
        AvailableDate: '',
        VehicleAmount: vehicle.VehicleAmount || ''
      });
      this.ShowAvailabilityDate = false;
    } else {
      this.selectedVehicles = this.selectedVehicles.filter(v => v.VehicleReqiredId !== VehicleReqiredId);
      this.ShowAvailabilityDate = true;
    }
    this.calculateTotalBidAmount();
  }

  onAmountChange(vehicle: any) {
    const existingVehicle = this.selectedVehicles.find(v => v.VehicleReqiredId === vehicle.Id);
    if (existingVehicle) {
      existingVehicle.VehicleAmount = vehicle.VehicleAmount;
    }
    this.calculateTotalBidAmount();
  }

  onRateChange(vehicle: any) {
    const existingVehicle = this.selectedVehicles.find(v => v.VehicleReqiredId === vehicle.Id);
    if (existingVehicle) {
      existingVehicle.VehicleAmount = vehicle.VehicleAmount;
    }
    this.calculateTotalRateAmount();
  }

  calculateTotalBidAmount(): void {
    this.totalBidAmount = this.selectedVehicles.reduce((sum: number, vehicle: any) => {
      return sum + (parseFloat(vehicle.VehicleAmount) || 0);
    }, 0);
  }

  calculateTotalRateAmount(): void {
    this.totalRateAmount = this.VehicleData.reduce((sum: number, vehicle: any) => {
      return sum + (parseFloat(vehicle.VehicleAmount) || 0);
    }, 0);
  }

  isSubmitting = false;
  isAccepted = false;

  //added by fahim 20-01-2026 :)
  SubmitTransporterShipment(){
    if (!this.ShipNowChargeBreakupList || this.ShipNowChargeBreakupList.length === 0) {
      this.AcceptShipment();
      return;
    }

    this.saveShipNowChargeBreakup((isSaved: boolean) => {
      if (!isSaved) {
        this.toastr.error('Failed to save charge breakup', 'Error');
        this.isSubmitting = false;
        return;
      }

      this.AcceptShipment();
    });

  }
  
  AcceptShipment() {
    if (this.isSubmitting) {
      console.log("AcceptShipment click ignored — already submitting.");
      return;
    }

    if (
      !this.commonService.ValidateRequiredField(
        $("#Amount"),
        "Please Enter Amount",
        "after",
        ""
      )
    ) {
      return;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#transporter"),
        "Please select",
        "after",
        ""
      )
    ) {
      return;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#AvailableDate"),
        "Please select Date",
        "after",
        ""
      )
    ) {
      return;
    }

    this.isSubmitting = true;
    this.GetTotalAmount(); //added by fahim 05-01-2026

    this.selectedVehicles = this.OrderData.VehicleList.map((vehicle: any) => ({
      VehicleTypeName: vehicle.VehicleTypeName,
      AvailableDate: this.currentDate,
      Qty: vehicle.Qty,
      VehicleAmount: vehicle.VehicleAmount || 0,
      VehicleReqiredId: vehicle.Id,
    }));
    // this.BidTransporter.Amount = this.totalRateAmount;
    if (this.totalChargeRateAmount === 0) {
      this.BidTransporter.Amount = this.totalRateAmount;
    } else {
      this.BidTransporter.Amount = this.totalChargeRateAmount;
    }

    // this.VehicleDetails = this.selectedVehicles;
    this.VehicleDetails = this.selectedVehiclesNEW;
    this.BidTransporter.IndentId = this.IndentId;
    this.BidTransporter.TransporterId = this.TransporterId;
    this.BidTransporter.BiddingDetails = this.VehicleDetails
    this.BidTransporter.IsContracted = true

    console.log('NewselectedVehicles inside save',this.NewselectedVehicles);
    console.log('BidTransporter',this.BidTransporter);
    console.log('this.OrderData.VehicleList',this.OrderData.VehicleList);
    this._appService.Post("OrdersByVehicle", "UpdateNewTransporterContract", this.BidTransporter).subscribe((response) => {
      if (response[0].isDone) {
        this.toastr.success("Request Accepted sucessfully !", "Success");
        this.isAccepted = true;
        this.GetRequiredData();
      } else {
        this.toastr.error("Your Request Acceptance Submission Failed !", "Error");
      }
      if (!this.isAccepted) {
        this.isSubmitting = false;
      }
      Helpers.setLoading(false);
    },
      (err) => {
        console.log(err);
        this.isSubmitting = false;
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  async calculateRouteOptimization(OrderInfoData, DestinationLocation): Promise<Observable<any>> {
    try {
      if (DestinationLocation.length > 1) {
        const directionsService = new google.maps.DirectionsService();
        const waypts = [];
        for (let i = 0; i < DestinationLocation.length; i++) {
          waypts.push({
            location: DestinationLocation[i].location,
            stopover: true,
          });
        }
        await directionsService.route(
          {
            origin: OrderInfoData[0].origin,
            destination: OrderInfoData[0].destination,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              let ViewPoints = [];
              ViewPoints = response.routes[0].waypoint_order;
              var mainNum = 65;
              var subNum = 63;
              for (let i = 0; i < ViewPoints.length; i++) {
                DestinationLocation[ViewPoints[i]].Order = i;
                DestinationLocation[ViewPoints[i]].RouteOrder =
                  subNum == 63
                    ? String.fromCharCode(mainNum)
                    : String.fromCharCode(mainNum) +
                    String.fromCharCode(subNum);
                if (mainNum == 90 || subNum == 90) {
                  mainNum = subNum == 63 ? 65 : mainNum + 1;
                  subNum = 64;
                }
                subNum = subNum == 63 ? subNum : subNum + 1;
                mainNum = subNum == 63 ? mainNum + 1 : mainNum;
              }
              // this.OrderDestinationLocation1=(DestinationLocation);
              // return this.OrderDestinationLocation1;
            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    } catch (error) {
      return DestinationLocation;
    }
    return DestinationLocation;
  }

  //added by vithu 23-08-2025 - Siddarth
  BookingData: any = {};
  TripDataForBidding() {
    this._appService
      .GetByTwoId("OrdersByVehicle", "TripDataForBidding", this.BookingId, this.TransporterId)
      .subscribe(
        (response) => {
          this.BookingData = response.Table[0];
          this.BookingData.ProductList = [];
          this.BookingData.ProductList = response.Table1;
          this.BookingData.SumOfQty = 0;
          this.BookingData.SumOfWeight = 0;
          this.BookingData.ProductList.forEach(element => {
            this.BookingData.SumOfQty += parseFloat(element.Qty);
            this.BookingData.SumOfWeight += parseFloat(element.Weight);
          });

          if (this.BookingData.BidOpen == false || this.BookingData.BidOpen == null) {
            this.isBidOpen = true;
          } else {
            this.isBidOpen = false;
          }

          if(!this.isBidOpen){
            this.stopInterval();
          }

          this.BookingData.VehicleData = response.Table2;
          if (this.BookingData.VehicleData.length <= 0) {
            this.AddRow();
          }
          var i: any = 0;
          if (this.BookingData.VehicleData.length > 0) {
            this.totalBidAmount = this.BookingData.VehicleData[0].Amount;
            this.BidTransporter.Remark = this.BookingData.VehicleData[0].Remark;
          } else {
            this.totalBidAmount = 0;
          }
          this.cdRef.detectChanges();
          this.BookingData.VehicleData.forEach((element, i) => {
            const selectElement = $("#VehicleType_" + i);
            this.InitSelect2OnElement(selectElement);

            element.Qty = 1;
            element.VehicleAmount = element.Amount;
            element.PickupDate = this.datepipe.transform(element.AvailableDate_bid, "yyyy-MM-dd");
            this.VehicleData.push(element);

          });
          setTimeout(() => {
            this.VehicleData.forEach(element => {
              if (this.BookingData.VehicleTypeId) {
                var k = 0;
                const selectElement = $("#VehicleType_" + k);
                // Select the value in Select2
                const selectedOption = {
                  id: BidTransporterComponent.that.BookingData.VehicleTypeId,
                  text: BidTransporterComponent.that.BookingData.VehicleType,
                };

                if (selectElement.find("option[value='" + selectedOption.id + "']").length === 0) {
                  const newOption = new Option(selectedOption.text, selectedOption.id, true, true);
                  selectElement.append(newOption).trigger('change');
                } else {
                  selectElement.val(selectedOption.id).trigger('change');
                }
              } else {

                const selectElement = $("#VehicleType_" + i);
                // Select the value in Select2
                const selectedOption = {
                  id: element.VehicleTypeId,
                  text: element.VehicleTypeName,
                };

                if (selectElement.find("option[value='" + selectedOption.id + "']").length === 0) {
                  const newOption = new Option(selectedOption.text, selectedOption.id, true, true);
                  selectElement.append(newOption).trigger('change');
                } else {
                  selectElement.val(selectedOption.id).trigger('change');
                }
              }

              if (this.BookingData.PickupDate && !element.PickupDate) {
                this.VehicleData[0].PickupDate = this.datepipe.transform(this.BookingData.PickupDate, "yyyy-MM-dd");
              }
            });
          }, 100); // A short delay is still good to allow DOM paint

          console.log('BookingData', this.BookingData)
          this.GetTransporterListHired();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching data !",
            "error"
          );
        }
      );
  }

  AddressList: any = [];
  GetAddressSequenceById() {
    this.AddressList = [];
    this._appService
      .GetById("Booking", "GetAddressSequenceById", this.BookingId)
      .subscribe(
        (response) => {
          this.AddressList = response;
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  GetSelectVehicleType() {
    $(".VehicleTypeForOrder").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 1,
      ajax: {
        global: false,
        url: environment.apiUrl + 'api/VehicleMaster/GetVehicleTypeSelect2',
        headers: {
          "Authorization": BidTransporterComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            param1: params.term, // or 'q': params.term depending on API
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Vehicle Type",
    });
  }

  AddRow() {
    var obj: any = {};
    obj.VehicleTypeId = null;
    obj.PickupDate = null;
    obj.Qty = 1;
    obj.VehicleAmount = 0;
    this.VehicleData.push(obj);

    // Wait for DOM to update before initializing Select2
    setTimeout(() => {
      // Find the last added select element
      const lastSelect = $(".VehicleTypeForOrder").last();
      this.InitSelect2OnElement(lastSelect);
    }, 0);
  }

  InitSelect2OnElement($element) {
    $element.select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 1,
      placeholder: "Search for Vehicle Type",
      allowClear: true,
      ajax: {
        global: false,
        url: environment.apiUrl + 'api/VehicleMaster/GetVehicleTypeSelect2',
        headers: {
          "Authorization": BidTransporterComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        data: function (params) {
          return {
            param1: params.term
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
    });
  }

  calculateTotalBidAmountTrip(event: any): void {
    this.totalBidAmount = this.VehicleData.reduce((sum: number, vehicle: any) => {
      return sum + (parseFloat(vehicle.VehicleAmount) || 0);
    }, 0);
  }

  UpdateTransporterBidsForTrip() {

    if (this.VehicleData.length == 0) {
      this.toastr.info('Please Select Atleast One VehcileType', 'info')
      return
    }
    for (let index = 0; index < this.VehicleData.length; index++) {
      const element = this.VehicleData[index];
      this.VehicleData[index].VehicleTypeId = $("#VehicleType_" + index).val();
      this.VehicleData[index].AvailableDate = this.datepipe.transform(element.PickupDate, "yyyy-MM-dd");

      if (!element.PickupDate) {
        this.toastr.error('Please select available date.', 'Error');
        return;
      }
      if (!element.VehicleAmount) {
        this.toastr.error('Please enter amount.', 'Error');
        return;
      }
      if ($("#VehicleType_" + index).val() == "" || $("#VehicleType_" + index).val() == null || $("#VehicleType_" + index).val() == undefined) {
        this.toastr.error('Please select vehicle type.', 'Error');
        return;
      }
    }

    this.isSubmitting = true;
    this.BidTransporter.Amount = this.totalBidAmount;
    this.BidTransporter.BookingId = this.BookingId;
    this.BidTransporter.TransporterId = this.TransporterId;
    this.BidTransporter.Vehicleslist = this.VehicleData;
    this.BidTransporter.IsContracted = false
    this._appService
      .Post("OrdersByVehicle", "UpdateTransporterBidForTrip", this.BidTransporter)
      .subscribe(
        (response) => {
          Helpers.setLoading(false);
          this.isSubmitting = false;
          if (response[0].isDone) {
            this.toastr.success("Bid Sent sucessfully !", "Success");
          } else {
            this.toastr.error("Your Bid Submission Failed !", "Error");
          }

        },
        (err) => {
          console.log(err);
          Helpers.setLoading(false);
          this.isSubmitting = false
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  openDropPointModal() {
    // this.GetOrderRouteAndLoadPlan(this.BookingId);
    $("#ModalRouteOptBid").modal('show');
  }

  closeDropPointsModal() {
    $('#ModalRouteOptBid').modal('hide');
  }

  @ViewChild(WaypointsMapComponent) ChildWaypointsMapComponent: WaypointsMapComponent;
  GetOrderRouteAndLoadPlan(BookingID) {
    this._appService
      .GetById("Booking", "GetOrderRouteAndPlan", BookingID)
      .subscribe(
        (response) => {
          var WayPointsres: any = [];
          var res: any = [];
          var PickUpPoints: any = [];
          WayPointsres.push(
            ...response.map((o) => {
              return {
                location: o.DeliveryAddress,
                stopover: true,
                Order: 0,
                RouteOrder: "A",
                OrderNo: o.OrderNo,
                PickUpContactPersonDetail: o.PickUpContactPersonDetail,
                DeliveryContactPersonDetail: o.DeliveryContactPersonDetail,
                OrderAddress: o.DeliveryAddress,
                weight: o.weight,
                Qty: o.Qty,
                cbm: o.cbm,
              };
            })
          );
          var objPickupLocation: any = {};
          (objPickupLocation.origin = response[0].PickupAddress),
            (objPickupLocation.destination =
              response[response.length - 1].DeliveryAddress),
            (objPickupLocation.TripNo = response[0].TripNo),
            (objPickupLocation.DispatchDate = response[0].DispatchDate),
            (objPickupLocation.Transporter = response[0].Transporter),
            (objPickupLocation.TransporterPhone = response[0].TransporterPhone),
            (objPickupLocation.Driver = response[0].Driver),
            (objPickupLocation.DriverPhone = response[0].DriverPhone),
            (objPickupLocation.Vehicle = response[0].Vehicle),
            (objPickupLocation.VehicleType = response[0].VehicleType);
          PickUpPoints.push(objPickupLocation);

          this.ChildWaypointsMapComponent.OrderInfoLatLong = [
            {
              origin: response[0].PickupAddressLatLong,
              destination: response[0].DeliveryAddressLatLong,
            },
          ];
          //add by maaria on 19-10-2023
          this.ChildWaypointsMapComponent.isAssign = false;
          //end
          this.ChildWaypointsMapComponent.OrderInfo = PickUpPoints;
          this.ChildWaypointsMapComponent.OrderDestinationLocation =
            WayPointsres;
          this.ChildWaypointsMapComponent.initMap();
          $("#ModalRouteOptBid").modal("show");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  GetLowestTransporterBid() {
    var isTripWiseBid: boolean = false;
    if(this.BookingId){
      isTripWiseBid = true;
    } else {
      isTripWiseBid = false;
    }

    this._appService
      .GetByThreeId("OrdersByVehicle", "GetLowestTransporterBid", isTripWiseBid, this.IndentId, this.BookingId)
      .subscribe(
        (response) => {
          this.lowestBidAmount = response[0].BidAmount;
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching data !",
            "error"
          );
        }
      );
  }

  private intervalSubscription: Subscription | null = null;
  startInterval() {
      if (this.intervalSubscription) return; // prevent multiple intervals
  
      this.intervalSubscription = interval(3000).subscribe(() => {
        this.GetLowestTransporterBid();
      });
    }

  //added by fahim 05-01-2026 :)
  GetShipNowChargeBreakupList() {
  Helpers.setLoading(true)
  this._appService.GetByThreeId('OrdersByVehicle', 'GetShipNowChargeBreakupList', this.IndentId, this.TransporterId,false).subscribe(
    (response) => {
      if(response.length){
        this.ShipNowChargeBreakupList = response || [];
        this.ShipNowChargeBreakupList = response.map((item, index) => {
          return {
            ...item,
            SerialNumber: index + 1
          };
        });
      }
      this.CalFooterValue();
      Helpers.setLoading(false)
    },
    (err) => {
      this.toastr.error("Error occurred while fetching data !", "error");
      Helpers.setLoading(false)
    }
  );
  }

  CalFooterValue() {
    this.ChargeBreakupTotalQty=0;
    this.ChargeBreakupTotalRate=0;
    this.ChargeBreakupTotalAmount=0;

    var TotalQty = 0;
    var TotalRate = 0;
    var TotalAmount = 0;

    this.ShipNowChargeBreakupList.forEach((element) => {
      TotalQty += parseFloat(element.Qty);
      TotalRate += parseFloat(element.Rate);
      TotalAmount += parseFloat(element.Amount);
    });

    setTimeout(() => {
      this.ChargeBreakupTotalQty = parseFloat(TotalQty.toString()).toFixed(2);
      this.ChargeBreakupTotalRate = parseFloat(TotalRate.toString()).toFixed(2);
      this.ChargeBreakupTotalAmount = parseFloat(TotalAmount.toString()).toFixed(2);
    }, 500);
  }

  onChargeBreakupRateChange(ele){
    console.log('ele',ele);
    this.selectedRate=0;
    if(ele){
      this.selectedRate=Number(ele.Rate)
    }

    const rate = Number(ele.Rate) || 0;

    const updatedRow = this.ShipNowChargeBreakupList.find(x => x.Id === ele.Id);
    if (updatedRow) {
        updatedRow.Amount = updatedRow.Qty * rate;
    }

    this.GetTotalAmount();
    this.CalFooterValue();
  }

   onSaveChargeBreakup(row: any){
    if(this.selectedRate === 0){
      this.selectedRate = row.Rate;
      this.selectedAmount = row.Amount;
    }else{
      this.selectedAmount = row.Amount;
    }
    let Id=row.Id
    this._appService.GetBySevenId('OrdersByVehicle','UpdateShipNowChargeBreakupRate',Id,this.selectedRate,this.selectedAmount,row.Qty,this.UserId,row.Unit,null).subscribe(
      (response)=>{
        this.toastr.success('Rate updated successfully','Success');
        this.GetShipNowChargeBreakupList();
      },
      (error)=>{
        this.toastr.error('Error while updating Rate','Error');
      }
    )
  }

  GetTotalAmount() {
    if (!this.ShipNowChargeBreakupList || this.ShipNowChargeBreakupList.length === 0) {
      this.totalChargeRateAmount = 0;
      return;
    }

    this.totalChargeRateAmount = this.ShipNowChargeBreakupList.reduce(
      (sum: number, item: any) => sum + (Number(item.Amount) || 0),
      0
    );
  
    //added by fahim 20-01-2026 :)
    const vehicleTypeSums: { [key: string]: number } = {};
    const vehicleTypeCounts: { [key: string]: number } = {};

    this.ShipNowChargeBreakupList.forEach(item => {
      const typeId = item.VehicleTypeId;
      const amount = Number(item.Amount) || 0;

      if (!vehicleTypeSums[typeId]) {
        vehicleTypeSums[typeId] = amount;
        vehicleTypeCounts[typeId] = 1;
      } else {
        vehicleTypeSums[typeId] += amount;
        vehicleTypeCounts[typeId] += 1;
      }
    });

    this.selectedVehiclesNEW.forEach(vehicle => {
      const typeId = vehicle.VehicleTypeId;
      if (vehicleTypeSums[typeId] !== undefined) {
        vehicle.VehicleAmount = vehicleTypeSums[typeId];
      } else {
        vehicle.VehicleAmount = 0;
      }
    });


    console.log('selectedVehiclesNEW',this.selectedVehiclesNEW);
  }
  //End added by fahim 05-01-2026 :)

  //added by fahim 20-01-2026 :)
  GetTransportersBidsById(){
    this._appService.GetById('OrdersByVehicle','GetTransportersBidsById',this.TransportersBidsId).subscribe(
      (response)=>{
        if(response && response.length>0 ){
          console.log('response[0].IsContracted',response[0].IsContractedText,typeof response[0].IsContractedText);
          this.OrderData.IsContracted=response[0].IsContractedText;
          if(this.OrderData && this.OrderData.IsContracted === 'true'){
            this.GetShipNowChargeBreakupList();
          }
        }

        console.log('this.OrderData.IsContracted',this.OrderData.IsContracted);
      },
      (error)=>{
        console.error('Error while getting transporter contract data ','Error');
      }
    );
  }

   saveShipNowChargeBreakup(callback: any) {
    const obj = {
      CreatedBy: this.UserId,
      ShipNowChargeBreakup_Table: this.ShipNowChargeBreakupList,
      isBidding: false
    };
    this._appService
      .Post('OrdersByVehicle', 'SaveShipNowChargeBreakup', obj)
      .subscribe(
        (response) => {
          console.log('SaveShipNowChargeBreakup Success');
          callback(true);
        },
        (error) => {
          console.error('Error while saving SaveShipNowChargeBreakup');
          callback(false);
        }
      );
  }

  GetBidDetails() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetContractedRateDetails", this.IndentId, this.TransporterId).subscribe(
      (res) => {
         this.NewVehicleDetails = [];

        if( 
          res &&
          res.Table2 &&
          Array.isArray(res.Table2) &&
          res.Table2.length > 0
        ){
          this.NewVehicleDetails = res.Table2;
          this.OrderData.IsContracted=this.NewVehicleDetails[0].IsContractedText || 'false';
          console.log('this.NewVehicleDetails',this.NewVehicleDetails);

          if (this.NewVehicleDetails && this.NewVehicleDetails.length > 0) {
            for (let i = 0; i < this.NewVehicleDetails.length; i++) {
              const bd = this.NewVehicleDetails[i];

              this.selectedVehiclesNEW.push({
                bidDetailId: bd.Id,
                VehicleReqiredId: bd.OrdersItemByVehicleId,
                AvailableDate: bd.AvailableDate_bid,
                VehicleAmount: bd.Amount, 
                Remark: bd.Remark,
                VehicleTypeId: bd.VehicleTypeId
              });
            }
          }

          if(this.OrderData && this.OrderData.IsContracted === 'true'){
              this.GetShipNowChargeBreakupList();
            }
        }else{
           this.OrderData.IsContracted = 'false';
        }

      Helpers.setLoading(false);
      },
      (error)=>{
        Helpers.setLoading(false);
        console.error("GetBidDetails", error);
      }
    );
  }

  onDateChangeContract(value, field, row) {
    if (field == "AvailableDate") {
      const AvailableDate = value.target.value;
     this.updateSelectedVehicle({
        AvailableDate: AvailableDate,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    if (field == "RateAmount") {
      this.updateSelectedVehicle({
          VehicleAmount: value,
          bidDetailId: row.Id,
          VehicleReqiredId: row.OrdersItemByVehicleId,
          VehicleTypeId: row.VehicleTypeId
      });
    }
  }

  updateSelectedVehicle(
    updatedFields: Partial<{
      bidDetailId: any;
      VehicleReqiredId: any;
      AvailableDate: any;
      VehicleAmount: any;
      Remark: any;
      VehicleTypeId: any,
    }>
  ) {
    const existingVehicle = this.selectedVehiclesNEW.find(
      (vehicle) => vehicle.bidDetailId === updatedFields.bidDetailId
    );

    if (existingVehicle) {
      Object.assign(existingVehicle, updatedFields);
      console.log("BidTransporter existingVehicle:", this.selectedVehiclesNEW);
    } else {
      //   
      // Add a new entry with default values
      this.selectedVehiclesNEW.push({
        bidDetailId: null,
        VehicleReqiredId: null,
        AvailableDate: null,
        VehicleAmount: null,
        Remark: '',
        VehicleTypeId: null,
        ...updatedFields,
      });

      this.calculateTotalBidAmount();

      console.log("BidTransporter Not existingVehicle:", this.selectedVehiclesNEW);
    }
  }
  //End added by fahim 20-01-2026 :)
}
